export const processAuditCheckSheet = [
  {
    s_no: 1,
    look_At: 'Are previous audit observations closed ?',
    look_for: 'Should be closed',
    score: null,
    observation: '',
  },
  {
    s_no: 2,
    look_At: 'Is operator working as per Operation standard',
    look_for:
      'Should be follow',
    score: null,
    observation: '',
  },
  {
    s_no: 3,
    look_At: 'Verify the Process Flow Chart / Process Sequence of  the Running Component',
    look_for: 'Process sequence must be as per PFD. ',
    score: null,
    observation: '',
  },
  {
    s_no: 4,
    look_At: `Check the availability of Process Control Standards (Operation  Standard/WI${"'"}s) on machine`,
    look_for: 'PCS / Control Plan / Operation Standard must be Displayed / Available on line',
    score: null,
    observation: '',
  },
  {
    s_no: 5,
    look_At: 'Verify the process parameters as per Control Plan / Operation Standard on machine',
    look_for: 'All the process parameters must be within specification limit',
    score: null,
    observation: '',
  },
  {
    s_no: 6,
    look_At: 'Check the records as mentioned in Control Plan / Operation Standard',
    look_for: 'Recording must be as per specified frequency and in defined format & by competent person as defined',
    score: null,
    observation: '',
  },
  {
    s_no: 7,
    look_At: 'Verify that all the measuring instruments/ Gauges are calibrated & check the validity / Expiry date.',
    look_for: 'Calibration reports of  the Instruments / Gauges ',
    score: null,
    observation: '',
  },
  {
    s_no: 8,
    look_At: 'Verify that the machine check sheet is properly filled',
    look_for:
      'Check sheets must be upto date',
    score: null,
    observation: '',
  },
  {
    s_no: 9,
    look_At: 'Check for Legibility  / Visibility of all the Displayed documents ',
    look_for: 'All the Displays must be Visible & Legible',
    score: null,
    observation: '',
  },
  {
    s_no: 10,
    look_At: 'Check for the availability of Master samples / Limit Samples / FOP samples etc.',
    look_for:
      'FOP & Master /Limit Samples must exist',
    score: null,
    observation: '',
  },
  {
    s_no: 11,
    look_At: 'Verify proper disposition of Non Conforming products',
    look_for:
      'Rework / Scrap Notes & Countermeasure reports must be produced',
    score: null,
    observation: '',
  },
  {
    s_no: 12,
    look_At: 'Check the competency of Operator / Inspector',
    look_for: 'Verify Skill / Competence Matrix ',
    score: null,
    observation: '',
  },
  {
    s_no: 13,
    look_At: "Verify the Countermeasures of  problems (Internal & External) ",
    look_for: 'Verify the effective implementation of Countermeasures & awareness among concerned peoples',
    score: null,
    observation: '',
  },
  {
    s_no: 14,
    look_At: 'Check & Verify the Machine / Tool / Jig / Fixture conditions (Maintenance of Production Equipments/ Machine/ Tool)',
    look_for: 'All the Machines / tools must have been maintained as per plan',
    score: null,
    observation: '',
  },
  {
    s_no: 15,
    look_At: 'Verify the effective implementation / functioning of Poka-Yoke Mechanism',
    look_for: 'Poka-Yoke mechanism must be functioning well',
    score: null,
    observation: '',
  },
  {
    s_no: 16,
    look_At: 'Check for identification & traceability',
    look_for:
      'All the parts must be properly identified & traceable( Identification Tags )',
    score: null,
    observation: '',
  },
  {
    s_no: 17,
    look_At: 'Verification of Change Management.',
    look_for:
      'Quality check record must be maintained for upexpected /abnormal change & ECN must be properly implemented  ',
    score: null,
    observation: '',
  },
  {
    s_no: 18,
    look_At: 'Verify the implementation of Safety measures in the shop floor',
    look_for: 'PPEs  (Goggles, Gloves , Aprons, Nose masks , Shoes ,Ear Plugs etc.) must be effectively used  in shop floor',
    score: null,
    observation: '',
  },
  {
    s_no: 19,
    look_At: 'Check the availability of Red/Yellow/Ok Bins at shop floor.',
    look_for:
      'should be available',
    score: null,
    observation: '',
  },
];
